/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx, keyframes } from "@emotion/react";
import React from "react";

const summarySkeletonCardIndexes = [0, 1];

const summarySkeletonShimmer = keyframes`
  100% {
    transform: translateX(100%);
  }
`;

export const AdminSalesDashboardSummarySkeleton: React.FC = () => {
  return (
    <div
      css={styles.cardGrid}
      aria-busy="true"
      // eslint-disable-next-line no-restricted-syntax -- i18n 未対応
      aria-label="サマリーを読み込み中"
    >
      {summarySkeletonCardIndexes.map((index) => {
        return (
          <article css={styles.card} key={index}>
            <span css={[styles.skeletonBar, styles.skeletonLabel]} />
            <div css={styles.skeletonValueArea}>
              <span css={[styles.skeletonBar, styles.skeletonValue]} />
            </div>
          </article>
        );
      })}
    </div>
  );
};

const styles = {
  cardGrid: css`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 250px), 1fr));
    gap: 14px;
  `,
  card: css`
    container-type: inline-size;
    display: flex;
    flex-direction: column;
    padding: clamp(16px, 2.5vw, 24px);
    background: #1b2734;
    border: 1px solid #2e3d4c;
    border-radius: 10px;
    box-shadow: 0 1px 2px rgb(0 0 0 / 22%);
  `,
  skeletonBar: css`
    position: relative;
    display: block;
    overflow: hidden;
    background: #263544;
    border-radius: 8px;
    &::after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: linear-gradient(
        90deg,
        rgb(255 255 255 / 0%) 0%,
        rgb(255 255 255 / 10%) 50%,
        rgb(255 255 255 / 0%) 100%
      );
      animation: ${summarySkeletonShimmer} 1400ms ease-in-out infinite;
      transform: translateX(-100%);
    }
    @media (prefers-reduced-motion: reduce) {
      &::after {
        animation: none;
        transform: translateX(0);
      }
    }
  `,
  skeletonLabel: css`
    width: 72px;
    height: 16px;
  `,
  skeletonValueArea: css`
    display: flex;
    align-items: baseline;
    min-width: 0;
    margin-top: 10px;
  `,
  skeletonValue: css`
    width: min(68%, 220px);
    height: clamp(26px, 3.2vw, 34px);
    @supports (container-type: inline-size) {
      height: clamp(26px, 13cqw, 34px);
    }
  `,
};
